export default {
    project: 'Editable project',
    projectHelp: 'The project used to export this video, saved where the editing team can open it.',
    projectLocation: 'Project link or shared file path',
    projectPlaceholder: 'Paste the exact project file or cloud project link',
    projectRevision: 'Saved project version',
    projectRevisionHelp: 'Use a versioned filename or cloud revision ID. Keep this saved version after submitting.',
    projectRevisionPlaceholder: 'Example: Interview_v3.prproj or cloud revision 42',
    base: 'Started from',
    original: 'Original footage',
    baseHelp: 'Choose the version you actually used, including an earlier version requested by the client.',
    details: 'Project setup',
    optional: 'Optional',
    sequence: 'Sequence or composition',
    assets: 'Linked media and extra assets',
    assetsHelp: 'Leave blank when they are in the shared project folder. Include extra fonts, graphics, or audio stored elsewhere.',
    applicationVersion: 'Editing application version',
    setupHelp: 'Only add details that are needed to reopen or reproduce this version.',
    previousProject: 'Previous project',
    addNote: 'Add a production note',
    noteHelp: 'Only if there’s special setup, an extra file, or a workaround to know about.',
    noteLabel: 'Production note · Internal',
    notePlaceholder: 'Example: The lower third is linked to Graphics/Titles.aep in the shared folder. Edit the name in that file.',
    notesCarried: 'Production notes carried forward',
    retireNote: 'No longer applies',
    noteSource: 'From {version} · {author}',
    requests: 'Editing requests',
    completed: 'Completed',
    carriedRequest: 'Unresolved in an earlier version',
    statusError: 'Couldn’t update this request. Try again; your explanation is still here.',
    required: 'Required',
    markedComplete: '{done} of {total} marked complete in the editing brief',
    noRequests: 'No checklist items available. Review the editing brief.',
    reviewRequests: 'Review editing brief',
    refresh: 'Refresh requests',
    openRequests: '{count} requests still open',
    reason: 'What prevented completion?',
    reasonHelp: 'An explanation keeps this request open for human review.',
    reasonPlaceholder: 'Explain what is missing, what remains in this version, and where.',
    unavailable: 'We couldn’t check the full request list. Your submission will require human review.',
    loading: 'Loading project details…',
    loadError: 'Couldn’t load project details. Your selected file and notes are still here.',
    retry: 'Try again',
    submit: 'Submit version',
    submitReview: 'Submit for review',
    internal: 'Project details and production notes stay with this version for the editing team.',
    continueFrom: 'Continue from {version}',
    sourceProject: 'Project saved with this video',
    openProject: 'Open project',
    savedVersion: 'Saved version',
    accessUnverified: 'Shared access and project opening have not been verified.',
    noHandoff: 'No saved project details for this version. Check the editing brief and existing project files.',
    priorRequests: 'Unresolved in the submitted version',
    notes: 'Production notes',
    references: 'Brand & Saved Order used for this version',
    referenceHelp: 'Recorded at submission. Current client instructions in the editing brief take precedence.',
    savedOrder: 'Saved Order',
    fonts: 'Fonts',
    colors: 'Colors',
    priorDirection: 'Client revision instructions at submission',
    cannotSubmit: 'Complete the project details and explain each open request before submitting.',
}
